export default __webpack_public_path__ + "static/media/oxo_error.df649869.png";